import React from 'react';

/** Home page component */
export const Home = () => (
  <div>
    <h1>Hallo!</h1>
    <p>Welkom op het accountantsportaal</p>
  </div>
);
